import { render, staticRenderFns } from "./CampSettings.vue?vue&type=template&id=bc93b042"
import script from "./CampSettings.vue?vue&type=script&lang=js"
export * from "./CampSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports